import { inject, Injectable, signal } from '@angular/core';
import { TripService } from './trip.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meal } from '../models/meal';

@Injectable({
  providedIn: 'root',
})
export class MealFormService {
  tripService = inject(TripService);
  fb = inject(FormBuilder);
  mode = signal<'create' | 'edit'>('create');
  index = signal<number | null>(null);
  mealForm: FormGroup = this.createMealGroup();

  createMealGroup(): FormGroup {
    return this.fb.group({
      type: ['', Validators.required],
      mealPercentage: [
        1,
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
      localSeasonalPercent: [
        0,
        [Validators.required, Validators.min(0), Validators.max(100)],
      ],
    });
  }
  resetFormGroup() {
    this.mealForm = this.createMealGroup();
    this.mode.set('create');
    this.index.set(null);
  }

  submitMeal() {
    const meal: Meal = this.mealForm.value;

    let result;
    if (this.mode() === 'edit' && this.index() !== null) {
      result = this.tripService.updateMeal(meal, this.index()!);
    } else {
      result = this.tripService.addMeal(meal);
    }

    // Validation will be triggered by trip service after save completes

    return result;
  }

  editMeal(index: number) {
    this.mode.set('edit');
    this.index.set(index);
    const meal = this.tripService.trip()?.meals[index];
    if (!meal) {
      console.error('could not load meal');
      return;
    }
    // Reset the existing form instead of creating a new one to keep FormControl references
    this.mealForm.reset({
      type: meal.type,
      mealPercentage: meal.mealPercentage,
      localSeasonalPercent: meal.localSeasonalPercent
    });
  }
}
